import React from 'react';

const stockIcon = (width,height,color) =>
    <svg width={width ? width:'25'} height={height ? height:'25'} viewBox='0 0 24 24' fill={color ? color:'#fff'} xmlns='http://www.w3.org/2000/svg'>
        <path d='M 6.394531 0 L 0 4.253906 L 4.449219 7.925781 L 10.847656 3.832031 Z M 0 11.496094 L 6.394531 15.800781 L 10.847656 11.96875 L 4.449219 7.925781 Z M 10.847656 11.96875 L 15.347656 15.800781 L 21.691406 11.550781 L 17.292969 7.925781 Z M 21.691406 4.253906 L 15.347656 0 L 10.847656 3.832031 L 17.292969 7.925781 Z M 10.898438 12.808594 L 6.394531 16.640625 L 4.503906 15.328125 L 4.503906 16.800781 L 10.898438 20.738281 L 17.292969 16.800781 L 17.292969 15.328125 L 15.347656 16.640625 Z M 10.898438 12.808594'/>
    </svg>;

export default stockIcon;
